import assetPath from '/app/packages/lebenslauf/articles/src/assets/anschreiben-aufbau.jpeg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')